import React from "react";

const Step = ({ icon, title, text }) => (
  <div className="how__step">
    <div className="how__icon">{icon}</div>
    <h4>{title}</h4>
    <p>{text}</p>
  </div>
);

export default function HowItWorks() {
  return (
    <section className="how">
      <div className="container">
        <h2 className="section__title">How It Works</h2>
        <div className="how__grid">
          <Step icon="🧭" title="Diagnostic" text="We assess your baseline and time-to-goal." />
          <Step icon="📝" title="Plan" text="You get a weekly study plan with checkpoints." />
          <Step icon="🏋️" title="Practice" text="Live drills, mocks, reviews with detailed debriefs." />
        </div>
        <div className="how__note">
          Note: The official CMT curriculum and exam are provided by the CMT Association. Our prep courses are supplemental and independently developed by The Bulls Trading Academy.
        </div>
      </div>
    </section>
  );
}
